export namespace PermissionEnum {
  export const code = Object.freeze({
    /* ADMIN */
    adminViewList: 'ADMIN_VIEW_LIST',
    adminCreate: 'ADMIN_CREATE',
    adminViewDetail: 'ADMIN_VIEW_DETAIL',
    adminEditDetail: 'ADMIN_EDIT_DETAIL',
    adminEditRole: 'ADMIN_EDIT_ROLE',
    adminEditStatus: 'ADMIN_EDIT_STATUS',
    adminViewActivity: 'ADMIN_VIEW_ACTIVITY',

    /* PRODUCT */
    productViewList: 'PRODUCT_VIEW_LIST',
    productCreate: 'PRODUCT_CREATE',
    productViewDetail: 'PRODUCT_VIEW_DETAIL',
    productEdit: 'PRODUCT_EDIT',
    productImportCode: 'PRODUCT_IMPORT_CODE',
    productDelete: 'PRODUCT_DELETE',

    /* COURSE */
    courseViewList: 'COURSE_VIEW_LIST',
    courseCreate: 'COURSE_CREATE',
    courseViewDetail: 'COURSE_VIEW_DETAIL',
    courseEdit: 'COURSE_EDIT',
    courseDelete: 'COURSE_DELETE',

    /* PRODUCT CONFIG */
    productConfigViewList: 'PRODUCT_CONFIG_VIEW_LIST',
    productConfigEdit: 'PRODUCT_CONFIG_EDIT',
    productConfigDelete: 'PRODUCT_CONFIG_DELETE',

    /* NOTIFICATION */
    notificationViewList: 'NOTIFICATION_VIEW_LIST',
    notificationCreate: 'NOTIFICATION_CREATE',
    notificationViewDetail: 'NOTIFICATION_VIEW_DETAIL',
    notificationCancel: 'NOTIFICATION_CANCEL',

    /* REPORT */
    reportViewChatList: 'REPORT_VIEW_CHAT_LIST',
    reportExportChatFile: 'REPORT_EXPORT_CHAT_FILE',
    reportViewFeedbackList: 'REPORT_VIEW_FEEDBACK_LIST',
    reportExportFeedbackFile: 'REPORT_EXPORT_FEEDBACK_FILE',

    /* QUESTIONNAIRE */
    questionnaireViewList: 'QUESTIONNAIRE_VIEW_LIST',
    questionnaireCreate: 'QUESTIONNAIRE_CREATE',
    questionnaireEditStatus: 'QUESTIONNAIRE_EDIT_STATUS',
    questionnaireEditConsent: 'QUESTIONNAIRE_EDIT_CONSENT',
    questionnaireEditHealth: 'QUESTIONNAIRE_EDIT_HEALTH',
    questionnaireEditPreArrival: 'QUESTIONNAIRE_EDIT_PRE_ARRIVAL',
    questionnaireEditMedical: 'QUESTIONNAIRE_EDIT_MEDICAL',
    questionnaireEditLabTest: 'QUESTIONNAIRE_EDIT_LAB_TEST',
    questionnairePrintHealth: 'QUESTIONNAIRE_PRINT_HEALTH',
    questionnairePrintPreArrival: 'QUESTIONNAIRE_PRINT_PRE_ARRIVAL',
    questionnairePrintMedical: 'QUESTIONNAIRE_PRINT_MEDICAL',
    questionnaireDelete: 'QUESTIONNAIRE_DELETE',

    /* CHAT SETTING */
    chatSettingViewList: 'CHAT_SETTING_VIEW_LIST',
    chatSettingCreate: 'CHAT_SETTING_CREATE',
    chatSettingDelete: 'CHAT_SETTING_DELETE',

    /* CHAT ROOM */
    chatRoomViewRakxaWellness: 'CHAT_ROOM_VIEW_RAKXA_WELLNESS',
    chatRoomViewRxStore: 'CHAT_ROOM_VIEW_RX_STORE',
    chatRoomViewRxu: 'CHAT_ROOM_VIEW_RXU',
    chatRoomViewRxvWellness: 'CHAT_ROOM_VIEW_RXV_WELLNESS',
    chatRoomReplyRakxaWellness: 'CHAT_ROOM_REPLY_RAKXA_WELLNESS',
    chatRoomReplyRxStore: 'CHAT_ROOM_REPLY_RX_STORE',
    chatRoomReplyRxu: 'CHAT_ROOM_REPLY_RXU',
    chatRoomReplyRxvWellness: 'CHAT_ROOM_REPLY_RXV_WELLNESS',
    chatRoomEditUsername: 'CHAT_ROOM_EDIT_USERNAME',
    chatRoomAddNote: 'CHAT_ROOM_ADD_NOTE',

    /* CUSTOMER */
    customerViewList: 'CUSTOMER_VIEW_LIST',
    customerExportList: 'CUSTOMER_EXPORT_LIST',
    customerSendForgotPassword: 'CUSTOMER_SEND_FORGOT_PASSWORD',
    customerDeactivate: 'CUSTOMER_DEACTIVATE',
    customerDelete: 'CUSTOMER_DELETE',
    customerViewDetail: 'CUSTOMER_VIEW_DETAIL',
    customerEdit: 'CUSTOMER_EDIT',
    customerApproveAlumni: 'CUSTOMER_APPROVE_ALUMNI',
    customerViewVoucherList: 'CUSTOMER_VIEW_VOUCHER_LIST',
    customerViewNonApp: 'CUSTOMER_VIEW_NON_APP',
    customerCreateNonApp: 'CUSTOMER_CREATE_NON_APP',
    customerDeleteNonApp: 'CUSTOMER_DELETE_NON_APP',
    customerViewQuestionnaire: 'CUSTOMER_VIEW_QUESTIONNAIRE',
    customerViewPoint: 'CUSTOMER_VIEW_POINT',
    customerViewCreditSummary: 'CUSTOMER_VIEW_CREDIT_SUMMARY',
    customerCreateCreditSummary: 'CUSTOMER_CREATE_CREDIT_SUMMARY',
    customerExportCreditSummary: 'CUSTOMER_EXPORT_CREDIT_SUMMARY',
    customerDeleteCreditSummary: 'CUSTOMER_DELETE_CREDIT_SUMMARY',
    customerViewTransaction: 'CUSTOMER_VIEW_TRANSACTION',
    customerCreateTransaction: 'CUSTOMER_CREATE_TRANSACTION',
    customerExportTransaction: 'CUSTOMER_EXPORT_TRANSACTION',
    customerDeleteTransaction: 'CUSTOMER_DELETE_TRANSACTION',
    customerViewNominee: 'CUSTOMER_VIEW_NOMINEE',
    customerViewPrimary: 'CUSTOMER_VIEW_PRIMARY',
    customerViewActivityLog: 'CUSTOMER_VIEW_ACTIVITY_LOG',

    /* ORDER TRANSACTION */
    transactionViewList: 'TRANSACTION_VIEW_LIST',
    transactionExportList: 'TRANSACTION_EXPORT_LIST',
    transactionViewDetail: 'TRANSACTION_VIEW_DETAIL',
    transactionCreateNote: 'TRANSACTION_CREATE_NOTE',
    transactionEditNote: 'TRANSACTION_EDIT_NOTE',
    transactionDeleteNote: 'TRANSACTION_DELETE_NOTE',
    transactionVoidVoucher: 'TRANSACTION_VOID_VOUCHER',

    /* REARRANGE PACKAGE */
    rearrangeViewPackageCategory: 'REARRANGE_VIEW_PACKAGE_CATEGORY',
    rearrangeEditPackageCategory: 'REARRANGE_EDIT_PACKAGE_CATEGORY',
    rearrangeViewPackageList: 'REARRANGE_VIEW_PACKAGE_LIST',
    rearrangeEditPackageList: 'REARRANGE_EDIT_PACKAGE_LIST',
    /* REARRANGE COURSE */
    rearrangeViewCourseCategory: 'REARRANGE_VIEW_COURSE_CATEGORY',
    rearrangeEditCourseCategory: 'REARRANGE_EDIT_COURSE_CATEGORY',
    rearrangeViewCourseList: 'REARRANGE_VIEW_COURSE_LIST',
    rearrangeEditCourseList: 'REARRANGE_EDIT_COURSE_LIST',
    /* REARRANGE A LA CARTE */
    rearrangeViewALaCarteCategory: 'REARRANGE_VIEW_A_LA_CARTE_CATEGORY',
    rearrangeEditALaCarteCategory: 'REARRANGE_EDIT_A_LA_CARTE_CATEGORY',
    rearrangeViewALaCarteList: 'REARRANGE_VIEW_A_LA_CARTE_LIST',
    rearrangeEditALaCarteList: 'REARRANGE_EDIT_A_LA_CARTE_LIST',

    /* EVENT */
    eventViewList: 'EVENT_VIEW_LIST',
    eventCreate: 'EVENT_CREATE',
    eventEdit: 'EVENT_EDIT',
    eventDelete: 'EVENT_DELETE',

    /* NEWS */
    newsViewList: 'NEWS_VIEW_LIST',
    newsCreate: 'NEWS_CREATE',
    newsEdit: 'NEWS_EDIT',
    newsDelete: 'NEWS_DELETE',

    /* FEATURED CONTENT */
    featuredContentViewList: 'FEATURED_CONTENT_VIEW_LIST',
    featuredContentCreate: 'FEATURED_CONTENT_CREATE',
    featuredContentEdit: 'FEATURED_CONTENT_EDIT',
    featuredContentDelete: 'FEATURED_CONTENT_DELETE',
  });
}
